// extracted by mini-css-extract-plugin
export default {"container":"labelWithHelp_container__MDuWC","label":"labelWithHelp_label__es+fZ","icon":"labelWithHelp_icon__cghh8"};